import { PLPSearchParams } from "./types";

export const PLP_DEFAULT_LIMIT = 18;

export function getPlpLoadedPages(searchParams: PLPSearchParams) {
	const rawValue = Array.isArray(searchParams.lp) ? searchParams.lp[0] : searchParams.lp;
	const loadedPages = Number.parseInt(String(rawValue ?? "1"), 10);
	return Number.isFinite(loadedPages) && loadedPages > 1 ? loadedPages : 1;
}

export function buildProductListParams(searchParams: PLPSearchParams) {
	const params = new URLSearchParams();
	const baseLimit = Number.parseInt(String(searchParams.limit ?? PLP_DEFAULT_LIMIT), 10) || PLP_DEFAULT_LIMIT;
	params.set("limit", String(baseLimit));

	Object.keys(searchParams).forEach((name: keyof PLPSearchParams) => {
		if (name.search("attr_") > -1) {
			const id = name.replace("attr_", "");
			params.set(`attribute[${id}]`, Array.isArray(searchParams[name]) ? (searchParams[name] as string[]).join(",") : (searchParams[name] as string));
		}

		// cf_{part}: colour families on one part.
		if (name.startsWith("cf_")) {
			const value = searchParams[name as `cf_${string}`];
			if (value) params.set(`color_families[${name.slice(3)}]`, value);
		}

		if (name.match(/attribute\[.*\]/)) {
			let attrVal = searchParams[name];
			if (attrVal === "بله") attrVal = "1";
			if (attrVal === "خیر") attrVal = "0";

			params.set(name, Array.isArray(attrVal) ? attrVal.join(",") : attrVal);
		}
	});

	if (searchParams.page) params.set("page", String(searchParams.page));
	if (searchParams.search) params.set("search", String(decodeURI(searchParams.search)));
	if (searchParams.sort) params.set("sort", searchParams.sort);
	if (searchParams.product_class_slug) {
		const productClass = Array.isArray(searchParams.product_class_slug)
			? [...searchParams.product_class_slug].reverse()[0]
			: searchParams.product_class_slug;
		params.set("product_class_slug", productClass);
	}
	if (searchParams.maxp) params.set("max_price", searchParams.maxp);
	if (searchParams.minp) params.set("min_price", searchParams.minp);
	if (searchParams.lc) params.set("lens_colors", searchParams.lc);
	if (searchParams.fc) params.set("frame_colors", searchParams.fc);
	if (searchParams.pd) params.set("product_discount", searchParams.pd);
	if (searchParams.brand) params.set("brands", searchParams.brand);
	if (searchParams.brand_slug) params.set("brand_slug", searchParams.brand_slug);

	if (searchParams.collection_slug) params.set("collection_slug", searchParams.collection_slug);

	if (searchParams.has_discount) params.set("has_discount", searchParams.has_discount);
	if (searchParams.has_quantity) params.set("has_quantity", searchParams.has_quantity);

	return params;
}
